import { LLPInstallmentStatus, LLPType, OrderStatus } from '../enums';
import { Address } from './address';
import { OrderFile } from './order';
import { Product } from './product.interface.ts';
import { ShipmentType } from './shipment';

export interface GetLlpSimulation {
    productId: string;
    type: LLPType;
    shipmentType: ShipmentType;
}

export interface CreateLlp extends GetLlpSimulation {
    productId: string;
    type: LLPType;
    shipmentType: ShipmentType;
    shipmentAddress: Address;
    billingAddress: Address;
}

export interface LLPItem {
    id?: string;
    product: Product;
    advanceAmount: number;
    shipmentAmount: number;
    totalToPayAmount: number;
    soldToPayAmount: number;
    totalAmount: number;
    nextInstallmentAmount: number;
    nextInstallmentDate: Date;
    productId: string;
    type: LLPType;
    shipmentType: ShipmentType;
    shipmentAddress?: Address;
    billingAddress?: Address;
    installments: LLPInstallment[];
    paymentCode?: PaymentCode;
}

export interface PaymentCode {
    paymentIntent: string;
    ephemeralKey: string;
    customer: string;
}

interface LLPInstallment {
    id: string;
    amount: number;
    date: Date;
    status: LLPInstallmentStatus;
}

export interface LLPListItem {
    id: string;
    wooOrderId: number;
    createdAt: Date;
    orderStatus: OrderStatus;
    numberOfInstallments: number;
    isOverdue: boolean;
    productImage: string;
}

export interface MyLlp {
    id: string;
    wooOrderId: number;
    createdAt: Date;
    paymentMethod: string;
    productsCount: number; // always 1
    totalAmount: number;
    shipmentMethod: string;
    courier: string;
    numberOfInstallments: number;
    timeline: LlpTimeline[];
    llpProduct: LlpProduct;
    documents: OrderFile[];
    installments: MyLLPInstallment[];
    shipmentAddress: Address;
    //summary
    advancePaid: number;
    totalPaid: number;
    totalToPay: number;
    paymentCode?: PaymentCode;
}

export interface MyLLPInstallment extends LLPInstallment {
    id: string;
    name: string;
    canPay: boolean;
    isOverdue: boolean;
}

export interface LlpTimeline {
    status: string;
    date?: Date;
    isDone: boolean;
    isCurrent: boolean;
    isFuture: boolean;
}

export interface LlpProduct {
    id: string;
    primaryImage: string;
    brand: string;
    title: string;
    sellPrice: number;
    sku: string;
}
